export default __webpack_public_path__ + "static/media/diamond.6ec14638.png";